import api from '../../../../api';

export const SelectSelector = {
  SELECT: api.internals.ns.selector('select')
};
